import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/sonner";
import { I18nProvider } from "@/i18n";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, refetchOnWindowFocus: false, retry: 1 } },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <QueryClientProvider client={queryClient}>
    <I18nProvider>
      <App />
      <Toaster position="top-center" richColors />
    </I18nProvider>
  </QueryClientProvider>
);

// Fade out the branded launch splash once the app has mounted.
const _splash = document.getElementById("app-splash");
if (_splash) {
  setTimeout(() => {
    _splash.classList.add("app-splash-hide");
    setTimeout(() => _splash.remove(), 450);
  }, 400);
}

// Register the PWA service worker (production build only) so CrickTrack is
// installable on Android and works as a Trusted Web Activity (TWA) app.
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").catch(() => {});
  });
}
